import React from 'react'

export default function TermsAndConditions() {
    return (
        <div className='tc_cms_pages_wrapper  py-5 animate__animated animate__fadeIn'>

            <div className="container">

                <div className='main'>
                    <h1><span>Terms & Conditions</span></h1>
                    <p><strong>Navchr Online</strong></p>
                    <p>Trade Name: Navchr Online</p>
                    <p>Address: Plot No 10, Baniya Ka Bagh, Jaipur Bye Pass, Alwar, Rajasthan – 301001</p>
                    <p>Effective Date: 01/01/2026</p>

                    <h3>1. Introduction</h3>
                    <p>These Terms & Conditions govern the use of payment services on this website. By making a payment through our platform, you agree to comply with these terms.</p>

                    <h3>2. Payment Terms</h3>
                    <p>All payments made on the website are processed through secure and authorized payment gateways.</p>
                    <p>Customers agree to provide accurate payment details and ensure sufficient funds for successful transactions.</p>
                    <p>Navchr Online is not responsible for any transaction failure due to banking issues or third-party payment service providers.</p>

                    <h3>3. Order Confirmation</h3>
                    <p>Once the payment is successfully completed, an order confirmation will be shared via email or registered contact details.</p>
                    <p>In case of failed transactions where the amount is deducted, customers are advised to contact their bank first.</p>

                    <h3>4. Pricing & Charges</h3>
                    <p>All prices listed on the website are subject to change without prior notice.</p>
                    <p>Applicable taxes, convenience fees, or service charges may be added at checkout.</p>

                    <h3>5. Refund Policy</h3>
                    <p>Refunds, if applicable, will be processed as per our Refund Policy.</p>
                    <p>Customers are requested to refer to the Refund Policy available on the website for complete details.</p>

                    <h3>6. Shipping Policy</h3>
                    <p>Shipping and delivery terms are governed by our Shipping Policy.</p>
                    <p>Customers are requested to refer to the Shipping Policy for detailed information.</p>

                    <h3>7. Cancellation Policy</h3>
                    <p>Any cancellation requests will be subject to approval and may not be guaranteed once the order is processed.</p>

                    <h3>8. Liability Limitation</h3>
                    <p>Navchr Online shall not be held liable for any indirect, incidental, or consequential damages arising from payment transactions.</p>
                    <p>We are not responsible for delays or failures caused by third-party payment providers or technical issues.</p>

                    <h3>9. Fraud Prevention</h3>
                    <p>We reserve the right to cancel or reject any transaction suspected of fraud or unauthorized activity.</p>
                    <p>Additional verification may be required in certain cases.</p>

                    <h3>10. Governing Law</h3>
                    <p>These Terms & Conditions shall be governed by the laws of India.</p>
                    <p>Any disputes shall be subject to the jurisdiction of courts in Alwar, Rajasthan.</p>

                    <h3>11. Contact Information</h3>
                    <p>Navchr Online</p>
                    <p>Plot No 10, Baniya Ka Bagh, Jaipur Bye Pass, Alwar, Rajasthan – 301001</p>
                    <p>Phone: <a href="tel:9336111631">9336111631</a></p>
                    <p>Email: <a href="mailto:support@navchr.com">support@navchr.com</a></p>
                </div>

            </div>
        </div>
    )
}
